<template>
  <section :class="['ecom dismissable', {'dismissable--hide': !shouldDisplay, 'dismissable--warning': isWarning}]">
    <img v-if="!isWarning" class="ecom dismissable__icon" :src="icon || info"/>
    <img v-if="isWarning" class="ecom dismissable__icon-warn" :src="warn"/>
    <div class="ecom dismissable__content">
      <slot name="content"></slot>
    </div>
    <img v-if="showClose" @click="hide" class="ecom dismissable__close" :src="close" />
  </section>
</template>

<script>
import config from '@/config'

const { cdn } = config
export default {
  props: {
    showClose: {
      required: false,
      default: true
    },
    isWarning: {
      required: false,
      default: false
    },
    icon: null
  },
  data () {
    return {
      close: `${cdn}icons-x-close-hide.svg`,
      info: `${cdn}icons-info-pro-tip.svg`,
      warn: `${cdn}heavy-warning-icon.svg`,
      shouldDisplay: true
    }
  },
  methods: {
    hide () {
      this.shouldDisplay = false
      this.$emit('hide')
    },
    show () {
      this.shouldDisplay = true
    }
  }
}
</script>
